import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Link } from '@reach/router';
import { MoreVertical } from 'react-feather';
import boombassadorLogo from '../../images/boombassadorLogo.png';
import bwIcon from '../../images/menu/boomwritericon.png';
import NavLinks from './components/NavLinks';
import styles from './AppMenu.module.scss';

const AppMenu = ({ onLogout, user }) => {
    const [optionsOpen, setOptionsOpen] = useState(false);
    const optionsRef = useRef(null);
    const optionsButtonRef = useRef(null);

    useEffect(() => {
        if (!optionsOpen) return;
        const dismissOutside = event => {
            if (optionsRef.current && !optionsRef.current.contains(event.target)) setOptionsOpen(false);
        };
        const dismissOnEscape = event => {
            if (event.key === 'Escape') {
                setOptionsOpen(false);
                if (optionsButtonRef.current) {
                    optionsButtonRef.current.focus();
                }
            }
        };
        document.addEventListener('pointerdown', dismissOutside);
        document.addEventListener('keydown', dismissOnEscape);
        return () => {
            document.removeEventListener('pointerdown', dismissOutside);
            document.removeEventListener('keydown', dismissOnEscape);
        };
    }, [optionsOpen]);

    return(
        <Fragment>
            {
                user && (
                    <Fragment>
                        <header className={styles.mobileHeader}>
                            <div className={styles.mobileHeaderActions}>
                                {user.isBoombassador && (
                                    <Link to="/boombassador" className={styles.mobileBoombassador} aria-label="Open Boombassador">
                                        <img src={boombassadorLogo} alt="Boombassador" />
                                    </Link>
                                )}
                                <div className={styles.mobileOptions} ref={optionsRef} onBlur={event => {
                                    if (!event.currentTarget.contains(event.relatedTarget)) setOptionsOpen(false);
                                }}>
                                    <button
                                        type="button"
                                        ref={optionsButtonRef}
                                        className={styles.mobileOptionsButton}
                                        aria-label="Account options"
                                        aria-expanded={optionsOpen}
                                        aria-controls="mobile-account-options"
                                        onClick={() => setOptionsOpen(open => !open)}
                                    >
                                        <MoreVertical aria-hidden="true" />
                                    </button>
                                    {optionsOpen && (
                                        <div id="mobile-account-options" className={styles.mobileOptionsPanel}>
                                            <button type="button" onClick={() => {
                                                setOptionsOpen(false);
                                                onLogout();
                                            }}>Logout</button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </header>
                        <div className={styles.menu}>
                            <div className={styles.menuContent}>
                                <div className={styles.menuBrand}><Link to="/"><img src={bwIcon} alt="BoomReader" /></Link></div>
                                <NavLinks styles={styles} user={user} onLogout={onLogout} />
                            </div>
                        </div>
                    </Fragment>
                )
            }
        </Fragment>
    )
}

export default AppMenu;
